import React from "react";
import "./AboutMyselfPage.css";
const AboutMyselfImg = () => {
  return (
    <div className="aboutMyselfImgContainer">
      <img
        src="https://images.unsplash.com/photo-1579273166152-d725a4e2b755?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YmlyZHMlMjBvbiUyMGJyYW5jaCUyMGFydHxlbnwwfHwwfHx8MA%3D%3D"
        alt=""
      />
    </div>
  );
};

export default AboutMyselfImg;
